import { UploadOutlined } from '@mui/icons-material'
import { Box, Button, Stack, Typography } from '@mui/material'
import React, { FunctionComponent, SetStateAction, useState } from 'react';
import { FileSelectorDialog } from '../../dialogs/file-selector-dialog';
import { FileThumbnail } from '../../../shared/utils/file-type-icons';

export const FileUploadHelper: FunctionComponent<{
  fileData: File[],
  setFileData: React.Dispatch<SetStateAction<any>>,
  buttonCopy?: string,
  submitButtonCopy?: string,
  onSubmit?: () => void
  disableButton?: boolean,
  hidePreview?: boolean,
  allowedFileTypes?: string[],
}> = (
  {
    fileData,
    setFileData,
    buttonCopy = 'Add document',
    submitButtonCopy = 'Upload',
    onSubmit,
    disableButton = false,
    hidePreview = false,
    allowedFileTypes
  }) => {

    const [dialogActive, setDialogActive] = useState<boolean>(false);

    const getBlobImageUrl = (index: number) => {
      return URL.createObjectURL(fileData[index]);
    }

    const isImageFile = (file: File) => {
      return file.type.startsWith('image/');
    }

    const submitHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
      e.stopPropagation()
      e.preventDefault()
      setDialogActive(false);
      if (onSubmit) {
        onSubmit();
      }
    }

    return (
      <Box>
        <Stack display='flex' alignItems='center' direction='row-reverse' spacing={2}>
          <Button onClick={() => setDialogActive(true)} variant='text' sx={{ maxHeight: '44px' }} disabled={disableButton}>
            <UploadOutlined />
            <Typography sx={{ p: 0.5 }}>{buttonCopy}</Typography>
          </Button>
          <FileSelectorDialog
            dialogActive={dialogActive}
            cancelUpload={() => { setDialogActive(false) }}
            fileData={fileData}
            setFileData={setFileData}
            submitHandler={submitHandler}
            allowedFileTypes={allowedFileTypes} />
          {!dialogActive && fileData.length > 0 && !hidePreview && (
            <Box sx={{ display: 'flex', flexDirection: 'row', gap: 3, alignItems: 'center', mt: 2 }}>
              {fileData.map((file: File, index: number) => (
                <Box sx={{
                  maxWidth: '74px',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  textAlign: 'center'
                }} key={index}>
                  <FileThumbnail
                    file={file}
                    width={64}
                    height={64}
                    sx={{}}
                  />
                </Box>
              )
              )}
            </Box>
          )}
        </Stack>
      </Box>
    )
  }